<template>
  <div id="student-management">
    <b-modal ref="my-modal" centered hide-footer :title="(model.id === '' ? 'Tambah' : 'Perbarui') + ' Sablon'">
      <form v-on:submit.prevent="doSubmit">
        <div>
          <fg-input :required="true" for-input="title" type="text" name="title" id="title" label="title" placeholder="Masukkan nama Sablon" v-validate="modelValidations.title" :error="errors.first('title')" v-model="model.title" data-vv-as="title" />
          <fg-input for-input="capitalPrice" type="number" name="capitalPrice" id="capitalPrice" label="Harga modal" placeholder="Masukkan harga modal" v-model="model.capitalPrice" />
          <fg-input for-input="sellingPrice" type="number" name="sellingPrice" id="sellingPrice" label="Harga Jual" placeholder="Masukkan harga modal" v-model="model.sellingPrice" />
          <save-data-button :disabled="saveButtonData.isLoading" :is-create="model.id === ''" :state="saveButtonData.isLoading && saveButtonData.state === 1 ? 2 : saveButtonData.state" :is-loading="saveButtonData.isLoading" />
          <b-button variant="warning" class="float-right mr-3" @click="hideModal">Cancel</b-button>
        </div>
      </form>
    </b-modal>
    <card>
      <b-row>
        <b-col cols="12" class="text-right">
          <b-button id="show-btn" variant="primary" @click="showModal" title="Add Hospital Service"><font-awesome-icon icon="plus"/></b-button>
        </b-col>
      </b-row>
      <paginated-table ref="dataTable" :can-delete="false" :can-show="false" :modal-view="true" :param-no-id="true" :data-url="apiUrl" :data-key="dataKey" v-on:editData="doEdit" :data-columns="columns" :data-params="['is_active', 'name']">
        <template slot="content_created_by" slot-scope="defaultSlotScope">
          {{defaultSlotScope.rowData.created_by.name}} ({{defaultSlotScope.rowData.created_by.roles[0].name}})
        </template>
        <template slot="content_last_updated_by" slot-scope="defaultSlotScope">
          {{defaultSlotScope.rowData.last_updated_by.name}} ({{defaultSlotScope.rowData.last_updated_by.roles[0].name}})
        </template>
        <template slot="content_capital_price" slot-scope="defaultSlotScope">
          {{defaultSlotScope.rowData.capital_price? formatNumber(defaultSlotScope.rowData.capital_price) : 0}}
        </template>
        <template slot="content_selling_price" slot-scope="defaultSlotScope">
          {{defaultSlotScope.rowData.selling_price ? formatNumber(defaultSlotScope.rowData.selling_price) : 0}}
        </template>
      </paginated-table>
    </card>
  </div>
</template>
<script>
  import { Input, Checkbox, Switch } from 'element-ui'
  import PaginatedTable from '@/components/Tables/PaginatedTable'
  import SaveData from '@/components/Buttons/SaveData'
  import Cancel from '@/components/Buttons/Cancel'

  export default {
    components: {
      [Input.name]: Input,
      PaginatedTable,
      elCheckbox: Checkbox,
      SaveDataButton: SaveData,
      CancelButton: Cancel,
      LSwitch: Switch
    },
    data () {
      return {
        dataKey: 'sablon',
        apiUrl: window.AppConfig.apiUrl + 'sablon',
        columns: [
          {
            prop: 'title',
            label: 'Judul'
          },
          {
            prop: 'capital_price',
            label: 'Harga Modal'
          },
          {
            prop: 'selling_price',
            label: 'Harga Jual'
          },
          {
            prop: 'created_by',
            label: 'Dibuat Oleh'
          },
          {
            prop: 'last_updated_by',
            label: 'Diperbarui oleh'
          }
        ],
        fakeTableFilter: {
          is_active: !!this.$route.query.is_active
        },
        tableFilter: {
          is_active: this.$route.query.is_active,
          name: this.$route.query.name
        },
        saveButtonData: {
          isLoading: false,
          state: 1
        },
        model: {
          id: '',
          capitalPrice: null,
          sellingPrice: null,
          title: ''
        },
        modelValidations: {
          capitalPrice: {
            required: true
          },
          sellingPrice: {
            required: true
          },
          title: {
            required: true
          }
        }
      }
    },
    watch: {
      'fakeTableFilter.is_active' (value) {
        this.tableFilter.is_active = value ? 1 : null
        this.doFilter()
      }
    },
    methods: {
      doFilter () {
        this.$refs.dataTable.doFilter(this.tableFilter)
      },
      showModal () {
        this.resetData()
        this.$refs['my-modal'].show()
      },
      hideModal () {
        this.resetData()
        this.$refs['my-modal'].hide()
      },
      doEdit (row) {
        this.setData(row)
        this.$refs['my-modal'].show()
      },
      setData (item) {
        this.model.id = item.id
        this.model.capitalPrice = item.capital_price
        this.model.sellingPrice = item.selling_price
        this.model.title = item.title
      },
      resetData (item) {
        this.model.id = ''
        this.model.description = null
        this.model.name = ''
        this.$validator.reset()
      },
      doSubmit () {
        this.$validator.validateAll().then(res => {
          if (res) {
            this.saveButtonData.isLoading = true
            if (this.model.id !== '') {
              let model = {}
              Object.keys(this.model).forEach(element => {
                if (element !== 'id') {
                  model[element] = this.model[element]
                }
              })
              this.$http.patch(this.apiUrl + '/' + this.model.id, model).then(response => {
                this.saveButtonData.isLoading = false
                this.$store.dispatch('notification/success', 'Unit berhasil diperbarui.')
                this.$refs.dataTable.getDataTable()
                this.resetData()
                this.hideModal()
              }).catch(error => {
                this.saveButtonData.isLoading = false
                this.$store.dispatch('notification/error', error)
              })
            } else {
              this.$http.post(this.apiUrl, this.model).then(response => {
                this.saveButtonData.isLoading = false
                this.$store.dispatch('notification/success', 'Unit berhasil ditambah.')
                this.hideModal()
                this.resetData()
                this.$refs.dataTable.getDataTable()
              }).catch(error => {
                this.saveButtonData.isLoading = false
                this.$store.dispatch('notification/error', error)
              })
            }
          }
        })
      },
      formatNumber (num) {
        return 'Rp. ' + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',-'
      }
    },
    mounted () {
      // this.initData().requestsablon()
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Settings/Sablon/Index.vue